var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaDoble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 83,
    viewBox: "0 0 80 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flecha"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72 2.64307V29.3097C72 32.846 70.7989 36.2373 68.661 38.7378C66.5231 41.2383 63.6235 42.6431 60.6 42.6431H34",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45 29.6431L31.6667 42.9764L45 56.3097M28.3333 29.6431L15 42.9764L28.3333 56.3097",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaDoble);
export default __webpack_public_path__ + "static/media/FlechaDoble.8791c146b66ed5d2c737c06cd0fdb1cc.svg";
export { ForwardRef as ReactComponent };